import { createApp } from 'vue'
import { createPinia } from 'pinia'

import 'normalize.css/normalize.css'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import en from 'element-plus/es/locale/lang/en'

import '@/styles/index.scss'

import App from './App.vue'
import router from './router'

import '@/icons'
import '@/permission'
import SvgIcon from '@/components/SvgIcon/index.vue'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.component('svg-icon', SvgIcon)
app.use(ElementPlus, { locale: en })

// Global directive — prevents space key input on numeric/code fields
app.directive('no-space', {
  mounted(el) {
    el.addEventListener('keydown', (event) => {
      if (event.keyCode === 32 || event.key === ' ') {
        event.preventDefault()
      }
    })
  }
})

router.isReady().then(() => {
  app.mount('#app')
})
